import { useQuery } from '@tanstack/react-query';
import { apiClient } from '../apiClient';
import { getQueryKeyBase, QUERY_KEYS } from '../queryClient';

// Config
import { crudConfig } from '../../../conf/conceptDeterminationMethods';

export const getQueryKey = getQueryKeyBase.bind(null, QUERY_KEYS.CONCEPT_DETERMINATION_METHOD);

export const useConceptDeterminationMethodById = ({ sessionToken, codeId, queryOptions = {} }) => {
    const Client = apiClient(crudConfig);
    const query = useQuery({
        queryKey: getQueryKey(codeId),
        queryFn: () => Client.fetchOne(sessionToken, codeId),
        onSuccess: (data) => {
            // console.log('Success', data);
        },
        onError: (data) => {
            console.log('Error', data);
        },
        keepPreviousData: true,
        refetchOnWindowFocus: false,
        enabled: typeof codeId !== 'undefined',
        ...queryOptions
    });

    return {
        data: query.data,
        isLoading: query.isLoading,
        isError: query.isError,
        error: query.error,
        refetch: async () => {
            await query.refetch();
        }
    };
};
